import {Link} from "@aws-amplify/ui-react";
import React from "react";

const getLink = function(name, link) {
    return <Link
        key={name}
        color="#F4D03F"
        href={link}
        isExternal={true}
    >
        {name}
    </Link>
}

//new season 8 aspects
export const delayedExtinction = getLink("Aspect of Delayed Extinction", "https://www.wowhead.com/diablo-4/affix/aspect-of-delayed-extinction-2192357");
export const impendingDeluge = getLink("Aspect of Impending Deluge", "https://www.wowhead.com/diablo-4/affix/aspect-of-impending-deluge-2241686");
export const serviceAndSacrifice = getLink("Aspect of Service and Sacrifice", "https://www.wowhead.com/diablo-4/affix/aspect-of-service-and-sacrifice-2239052");
export const contamination = getLink("Aspect of Contamination", "https://www.wowhead.com/diablo-4/affix/aspect-of-contamination-2246466");
export const shivering = getLink("Shivering Aspect", "https://www.wowhead.com/diablo-4/affix/shivering-aspect-2249121");
export const ripAndTear = getLink("Rip and Tear Aspect", "https://www.wowhead.com/diablo-4/affix/rip-and-tear-aspect-2208083");




